import React from 'react';
import { HiBellAlert } from "react-icons/hi2";
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import ClickOutside from './clickOtside';
import "./popupNotification.css"
//import { seenNotification, getUnseenNotifications } from '../../services/notifications';
interface Notification {
  id: number;
  message: string;
  functionsAll: string;
  createdAt: Date;
  seen: boolean;
}

interface PopoverNotificationProps {
  isOpen: boolean;
  onClose: () => void;
  notifications?: any;
  updateNotifications: () => void;
}

const PopoverNotification: React.FC<PopoverNotificationProps> = ({
  isOpen,
  onClose,
  notifications = [],
  updateNotifications,
}) => {
  const navigate = useNavigate();

  const handleNavigation = (event: React.MouseEvent, notification: any) => {
    event.preventDefault();
  //console.log('Notification clicked:', notification);

    if (notification?.type.includes("Compliance Control Action") && notification?.actionId) {
        const ids = notification.actionId.split("/"); 
        if (ids.length >= 3) {
            const complianceId = ids[0]; 
            const domainId = ids[1];
            const controlId = ids[2]; 

            navigate(`/compliances/view-control/${controlId}/${complianceId}/${domainId}`);
        }
    } else if (notification?.type.includes("Public Survey")) {
        navigate('/surveys');
    } else if (notification?.type.includes("Workflow Approval") && notification?.actionId) {
        navigate(`/approvals/${notification.actionId}`);
    } else if (notification?.type.includes("Remediation") && notification?.actionId) {
        // actionId is the plan's own id - a plain detail link, unlike a compliance
        // action whose id is the compliance/domain/control triple.
        navigate(`/remediation/${notification.actionId}`);
    } else {
      //console.log("Notification type is not 'Compliance Control Action' or 'Public Survey', so no navigation.");
    }
};


  const goToAllNotifications = () => {
    updateNotifications();
    navigate('notification');
  };

  return (
    <div>
      <ClickOutside onClickOutside={onClose}>
        {isOpen && (
          <div
            className="notification-popup rounded shadow overflow-hidden"
           
          >
            <table className="w-full rounded" style={{width:"100%"}}>
              {notifications.length > 0 ? (
                <tbody style={{width:"100%"}}>
                  {notifications.map((notification:any) => (
                    <tr
                      key={notification?.id}
                      className={notification?.seen ? 'bg-gray-100' : 'bg-gray-200'}
                      onClick={(event) => handleNavigation(event, notification)}
                      style={{ cursor: 'pointer' ,width:"100%",borderBottom:"1px solid #e0e0e0"}}
                    >
                      <td className="px-2 py-2">
                        <div className="d-flex align-items-center">
                          <div className="w-8 h-8 rounded-circle notification-popup-icon d-flex align-items-center justify-content-center me-3">
                            <HiBellAlert className="w-5 h-5 text-white" />
                          </div>
                          <div>
                            <p className="fw-medium mb-1">{notification?.message}</p>
                            <p className="notification-popup-meta small mb-1">
                              Function: <b>{notification?.type}</b>
                            </p>
                            <p className="text-muted small">
                              Created on{' '}
                              <span>{format(new Date(notification?.createdAt), 'yyyy-MM-dd \'at\' hh:mm a')}</span>
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td className="px-6 py-4 text-center">
                      <p>No Notifications</p>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
            <div className="p-3 border-t">
              <button
                onClick={goToAllNotifications}
                className="btn w-100 text-white rounded notification-popup-cta"
              >
                Go to All
              </button>
            </div>
          </div>
        )}
      </ClickOutside>
    </div>
  );
};

export default PopoverNotification;